(() => {
  const formatMoney = (cents) => new Intl.NumberFormat('de-DE', {
    style: 'currency',
    currency: 'EUR'
  }).format(Number(cents || 0) / 100);

  document.querySelectorAll('[data-suedlis-catalog-toggle]').forEach((toggle) => {
    const panelId = toggle.getAttribute('aria-controls');
    const panel = panelId ? document.getElementById(panelId) : null;
    if (!panel) return;

    toggle.addEventListener('click', () => {
      const expanded = toggle.getAttribute('aria-expanded') === 'true';
      const label = toggle.querySelector('[data-suedlis-catalog-label]');
      panel.hidden = expanded;
      toggle.setAttribute('aria-expanded', String(!expanded));
      if (label) {
        label.textContent = expanded ? toggle.dataset.collapsedLabel : toggle.dataset.expandedLabel;
      }
      if (expanded) toggle.scrollIntoView({ block: 'nearest' });
    });
  });

  document.querySelectorAll('[data-suedlis-gallery]').forEach((gallery) => {
    const mainImage = gallery.querySelector('[data-suedlis-product-main-image]');
    const aiBadge = gallery.querySelector('[data-suedlis-ai-image-badge]');
    const thumbs = [...gallery.querySelectorAll('[data-suedlis-gallery-thumb]')];
    if (!mainImage || !thumbs.length) return;

    const showMedia = (thumb) => {
      mainImage.src = thumb.dataset.imageSrc;
      mainImage.srcset = '';
      mainImage.alt = thumb.dataset.imageAlt || '';
      if (aiBadge) aiBadge.hidden = thumb.dataset.imageIsAi !== 'true';
      thumbs.forEach((item) => {
        const active = item === thumb;
        item.classList.toggle('is-active', active);
        item.setAttribute('aria-pressed', String(active));
      });
    };

    thumbs.forEach((thumb) => thumb.addEventListener('click', () => showMedia(thumb)));
    gallery.suedlisShowMedia = (mediaId) => {
      const thumb = thumbs.find((item) => item.dataset.mediaId === String(mediaId));
      if (thumb) showMedia(thumb);
    };
  });

  document.querySelectorAll('[data-suedlis-quantity]').forEach((control) => {
    const input = control.querySelector('[data-suedlis-quantity-input]');
    if (!input) return;
    control.querySelectorAll('[data-suedlis-quantity-change]').forEach((button) => {
      button.addEventListener('click', () => {
        const change = Number(button.dataset.suedlisQuantityChange || 0);
        const minimum = Number(input.min || 1);
        input.value = String(Math.max(minimum, Number(input.value || minimum) + change));
        input.dispatchEvent(new Event('change', { bubbles: true }));
      });
    });
    input.addEventListener('change', () => {
      const minimum = Number(input.min || 1);
      if (!Number.isFinite(Number(input.value)) || Number(input.value) < minimum) input.value = String(minimum);
    });
  });

  document.querySelectorAll('[data-suedlis-product-root]').forEach((root) => {
    const form = root.querySelector('[data-suedlis-product-form]');
    const variantSelect = root.querySelector('[data-suedlis-variant-select]');
    const variantInput = root.querySelector('[data-suedlis-variant-id]');
    const variantData = root.querySelector('[data-suedlis-variants]');
    if (!form || !variantInput || !variantData) return;

    let variants = [];
    try {
      variants = JSON.parse(variantData.textContent || '[]');
    } catch (error) {
      console.error('SÜDLIS: Variantendaten konnten nicht gelesen werden.', error);
      return;
    }

    const updateVariant = (variantId) => {
      const variant = variants.find((item) => String(item.id) === String(variantId));
      if (!variant) return;
      variantInput.value = variant.id;

      const price = root.querySelector('[data-suedlis-current-price]');
      const compare = root.querySelector('[data-suedlis-compare-price]');
      const submit = root.querySelector('[data-suedlis-add-to-cart]');
      const submitLabel = root.querySelector('[data-suedlis-add-label]');
      const delivery = root.querySelector('[data-suedlis-delivery-status]');
      const deliveryLabel = root.querySelector('[data-suedlis-delivery-label]');
      if (price) price.textContent = formatMoney(variant.price);
      if (compare) {
        const hasDiscount = Number(variant.compare_at_price || 0) > Number(variant.price || 0);
        compare.hidden = !hasDiscount;
        compare.textContent = hasDiscount ? formatMoney(variant.compare_at_price) : '';
      }
      if (submit) submit.disabled = !variant.available;
      if (submitLabel) submitLabel.textContent = variant.available ? 'In den Warenkorb' : 'Ausverkauft';
      if (delivery) delivery.dataset.available = String(Boolean(variant.available));
      if (deliveryLabel && delivery) {
        deliveryLabel.textContent = variant.available ? delivery.dataset.availableLabel : delivery.dataset.soldoutLabel;
      }

      const closureChoice = form.querySelector('[data-suedlis-closure-choice]:checked');
      const featuredMediaId = (closureChoice && closureChoice.dataset.mediaId) || (variant.featured_media && variant.featured_media.id);
      const gallery = root.querySelector('[data-suedlis-gallery]');
      if (featuredMediaId && gallery && typeof gallery.suedlisShowMedia === 'function') gallery.suedlisShowMedia(featuredMediaId);

      const url = new URL(window.location.href);
      url.searchParams.set('variant', variant.id);
      window.history.replaceState({}, '', url);
    };

    if (variantSelect) variantSelect.addEventListener('change', () => updateVariant(variantSelect.value));

    if (root.hasAttribute('data-suedlis-meerbegleiter-standalone')) {
      const wristInput = form.querySelector('[data-suedlis-wrist-input]');
      const wristError = form.querySelector('[data-suedlis-wrist-error]');
      const fitChoices = form.querySelector('[data-suedlis-fit-choices]');
      const fitInputs = [...form.querySelectorAll('[data-suedlis-fit-choice]')];
      const closureInputs = [...form.querySelectorAll('[data-suedlis-closure-choice]')];
      const result = form.querySelector('[data-suedlis-fit-result]');
      const resultLength = form.querySelector('[data-suedlis-fit-length]');
      const resultDescription = form.querySelector('[data-suedlis-fit-description]');
      const unavailable = form.querySelector('[data-suedlis-fit-unavailable]');
      const submit = form.querySelector('[data-suedlis-add-to-cart]');
      const properties = {
        wrist: form.querySelector('[data-suedlis-property-wrist]'),
        fit: form.querySelector('[data-suedlis-property-fit]'),
        allowance: form.querySelector('[data-suedlis-property-allowance]'),
        length: form.querySelector('[data-suedlis-property-length]')
      };
      if (!wristInput || !wristError || !fitChoices || fitInputs.length !== 3 || !result || !resultLength || !resultDescription || !unavailable || !submit || Object.values(properties).some((input) => !input)) return;

      const parseWristTenths = (value) => {
        const normalized = value.trim().replace(',', '.');
        if (!/^\d{1,2}(?:\.\d)?$/.test(normalized)) return null;
        const tenths = Math.round(Number(normalized) * 10);
        return tenths >= 150 && tenths <= 250 ? tenths : null;
      };
      const centimeters = (tenths) => `${(tenths / 10).toFixed(1).replace('.', ',')} cm`;
      const sizeForWrist = (tenths) => tenths < 170 ? 'S' : tenths < 190 ? 'M' : tenths < 210 ? 'L' : 'XL';

      const updateFit = () => {
        const wristTenths = parseWristTenths(wristInput.value);
        const hasInput = wristInput.value.trim() !== '';
        const showError = wristTenths === null && (hasInput || wristInput.dataset.touched === 'true');
        wristError.hidden = !showError;
        wristInput.setAttribute('aria-invalid', String(showError));
        fitChoices.hidden = wristTenths === null;
        fitInputs.forEach((input) => { input.disabled = wristTenths === null; });

        const hasClosure = closureInputs.length === 0 || closureInputs.some((input) => input.checked);
        const fitInput = fitInputs.find((input) => input.checked);
        const fitMillimeters = fitInput ? Number(fitInput.value) : null;
        const hasFit = wristTenths !== null && [0, 5, 10].includes(fitMillimeters);
        result.hidden = !hasFit;
        unavailable.hidden = true;
        variantInput.value = '';
        variantInput.disabled = true;
        submit.disabled = true;
        Object.values(properties).forEach((input) => {
          input.value = '';
          input.disabled = true;
        });
        if (wristTenths === null) return false;

        const size = sizeForWrist(wristTenths);
        const variant = variants.find((item) => String(item.title || '').trim().toUpperCase() === size);
        if (!variant || !variant.available) {
          unavailable.hidden = false;
          if (variant) updateVariant(variant.id);
          variantInput.disabled = true;
        } else {
          updateVariant(variant.id);
        }
        submit.disabled = true;
        if (!hasFit) return false;

        const fitName = fitInput.closest('label').querySelector('.suedlis-mb-fit__card-title').textContent.trim();
        const wrist = centimeters(wristTenths);
        const length = centimeters(wristTenths + fitMillimeters);
        resultLength.textContent = length;
        resultDescription.textContent = result.dataset.descriptionTemplate
          .replace('{circumference}', wrist)
          .replace('{fit}', fitName)
          .replace('{length}', length);
        if (!variant || !variant.available || !hasClosure) return false;

        properties.wrist.value = wrist;
        properties.fit.value = fitName;
        properties.allowance.value = `+${fitMillimeters} mm`;
        properties.length.value = length;
        Object.values(properties).forEach((input) => { input.disabled = false; });
        variantInput.disabled = false;
        submit.disabled = false;
        return true;
      };

      wristInput.addEventListener('input', updateFit);
      wristInput.addEventListener('blur', () => {
        wristInput.dataset.touched = 'true';
        const wristTenths = parseWristTenths(wristInput.value);
        if (wristTenths !== null) wristInput.value = centimeters(wristTenths).replace(' cm', '');
        updateFit();
      });
      fitInputs.forEach((input) => input.addEventListener('change', updateFit));
      closureInputs.forEach((input) => input.addEventListener('change', () => {
        const gallery = root.querySelector('[data-suedlis-gallery]');
        if (input.checked && input.dataset.mediaId && gallery && typeof gallery.suedlisShowMedia === 'function') gallery.suedlisShowMedia(input.dataset.mediaId);
        updateFit();
      }));
      form.addEventListener('submit', (event) => {
        if (updateFit()) return;
        event.preventDefault();
        if (parseWristTenths(wristInput.value) === null) {
          wristInput.dataset.touched = 'true';
          updateFit();
          wristInput.focus();
        } else if (!fitInputs.some((input) => input.checked)) {
          fitInputs[0].focus();
        } else if (closureInputs.length && !closureInputs.some((input) => input.checked)) {
          closureInputs[0].focus();
        }
      });
      updateFit();
    }
  });
})();
